<template><div><h1 id="funtrade-im-zusammenspiel-mit-weiteren-systemen" tabindex="-1"><a class="header-anchor" href="#funtrade-im-zusammenspiel-mit-weiteren-systemen"><span>funtrade im Zusammenspiel mit weiteren Systemen</span></a></h1>
<SpotlightDetails :spotlight="spotlight1" /></div></template>


<script setup>
import { ref } from 'vue'

const spotlight1 = {
  videos: [
    {
      id: "video1",
      url: "https://player.vimeo.com/video/1162163558?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
      title: "Die System-Landschaft der fiktiven NPO Lebensbaum",
      description: "Am Beispiel der fiktiven NPO Lebensbaum zeigen wir, wie gewachsene Systemlandschaften zu Datensilos führen – und warum ein zentrales CRM als „Single Source of Truth“ entscheidend ist. Erfahre, wie funtrade im Zusammenspiel mit weiteren Systemen die Basis für strukturierte Integration mit APIs und Webhooks schafft.",
      width: 640,
      height: 360,
      speaker: "Christian Davatz",
    },
    {
      id: "video2",
      url: "https://player.vimeo.com/video/1162163623?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
      title: "Datenintegration in funtrade via API und Webhooks",
      description: "Wir erklären verständlich, wie Daten via API und Webhooks in funtrade integriert werden. Anhand der NPO Lebensbaum zeigen wir den Unterschied zwischen synchronen API-Prozessen mit direktem Nutzerfeedback und asynchrone Webhooks im Hintergrund – und wie beide gemeinsam für saubere, effiziente Datenflüsse sorgen.",
      width: 640,
      height: 360,
      speaker: "Christian Davatz",
    },
    {
      id: "video3",
      url: "https://player.vimeo.com/video/1165621013?title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479",
      title: "Die Rolle des Fundraisers",
      description: "Wir zeigen, welche Rolle Fundraiser:innen in einer vernetzten Systemlandschaft spielen. Anhand der NPO Lebensbaum wird sichtbar, wie APIs und Webhooks für eine 360°-Sicht, persönlichere Kommunikation und weniger manuelle Arbeit sorgen – und wie die neue funtrade REST API den Weg zu mehr Wirkung ebnet.",
      width: 640,
      height: 360,
      speaker: "Christian Davatz",
    }
  ]
}
</script>